// Import common components
import { Box, FlexBox } from '../../common/Box'
import Description from '../../common/Description'
import Title from '../../common/Title'

// Import themes modules
import { px2Rem } from '../../../themes/Mixins'
import COLORS from '../../../themes/Colors'
import TYPOGRAPHY from '../../../themes/Typography'

export const ServicesWrapper = FlexBox.extend`
  display: block;
  background-color: ${COLORS.bgService};
  padding: ${px2Rem(30)} ${px2Rem(25)};

  @media(min-width: 768px) {
    display: flex;
    align-items: center;
    padding: ${px2Rem(70)} 0;
  }
`

export const MainSectionWrapper = Box.extend`
  @media(min-width: 768px) {
    width: 33.33%;
  }
`

export const ServiceListWrapper = Box.extend`
  @media(min-width: 768px) {
    width: 66.66%;
    display: flex;
    flex-wrap: wrap;

    ${Box} {
      width: ${props => props.limitData.length > 4 ? '33.33%' : '50%'};
    }
  }
`

export const ServiceItemWrapper = FlexBox.extend`
  width: 100%;
  justify-content: center;
  flex-direction: column;
  postion: relative;

  @media(min-width: 768px) {
    padding: ${props => !props.icon ? `0 ${px2Rem(70)} 0 ${px2Rem(100)}` : ''};
  }


  ${Title} {
    font-family: ${props => props.icon ? TYPOGRAPHY.TYPE.bold : TYPOGRAPHY.TYPE.base};
    margin-left: ${props => props.icon ? px2Rem(10) : ''};
    color: ${COLORS.white};
    font-size: ${props => props.icon ? TYPOGRAPHY.SIZE.xTiny : TYPOGRAPHY.SIZE.xSmall};
  }

  ${Description} {
    color: ${COLORS.white};
    line-height: ${props => props.icon ? '1.57' : '1.56'};
    margin: ${props => props.icon ? `${px2Rem(5)} 0 0` : `${px2Rem(8)} 0 0`};
    font-family: ${TYPOGRAPHY.TYPE.base};
  }

  @media(min-width: 768px) {
    width: ${props => props.width};
    padding-right: ${props => props.paddingRight};

    ${Title} {
      font-family: ${props => props.icon ? TYPOGRAPHY.TYPE.bold : TYPOGRAPHY.TYPE.base};
      margin-left: ${props => props.icon ? px2Rem(20) : ''};
      font-size: ${props => props.icon ? TYPOGRAPHY.SIZE.xSmall : TYPOGRAPHY.SIZE.large};
    }

    ${Description} {
      margin: ${props => props.icon ? `0 0 0 ${px2Rem(70)}` : `${px2Rem(25)} 0 0`};
      font-family: ${TYPOGRAPHY.TYPE.light};
      font-size: ${props => props.icon ? px2Rem(14) : px2Rem(16)};
    }
  }
`

export const ServiceIcon = FlexBox.extend`
  justify-content: center;
  width: ${px2Rem(30)};
  height: ${px2Rem(30)};
  align-items: center;
  display: ${props => !props.icon ? 'none' : ''};

  @media(min-width: 768px) {
    width: ${px2Rem(50)};
    height: ${px2Rem(50)};
  }
`



// WEBPACK FOOTER //
// ./src/components/sections/services/ServiceResponsive.js